import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  deleteCategory,
  updateCategoryStatus,
} from "../../../api/testSeries/category";
console.log("row");
function SubCategoryRow(props) {
  const {
    row,
    index,
    deleteBtnHandler,
    setIsAddModalVisible,
    setEditIndex,
    setMode,
    setAddSubCategoryData,
    catid,
    catName,
  } = props;
  const [status, setStatus] = useState(row.status);

  const changeStatusBtnHandler = async (id, status) => {
    const response = updateCategoryStatus(id, status);
    if (response.status) {
      setStatus(status);
    }
  };
  console.log(row);
  return (
    <tr>
      <td align="center">{index + 1}</td>
      <td align="center">{row.title}</td>
      <td align="center">
        {/* <button
          aria-label="delete"
          onClick={() => deleteBtnHandler(row.id, index)}
          className="btn btn-danger mr-1"
        >
          Delete
        </button> */}
        <button
          aria-label="edit"
          onClick={() => {
            setEditIndex(index);
            setAddSubCategoryData(row);
            setMode("edit");
            setIsAddModalVisible(true);
          }}
          className="btn btn-danger mr-1"
        >
          Edit
        </button>
        <Link
          to={
            "/listing/" +
            row.id +
            "/" +
            row.title.replace(/\s/g, "") +
            "/" +
            catid +
            "/" +
            catName.replace(/\s/g, "")
          }
          aria-label="delete"
          className="btn btn-primary mr-1"
        >
          Test Series
        </Link>
        <Link
          to={"/subcategoryStats/" + row.id}
          aria-label="delete"
          className="btn btn-primary mr-1"
        >
          Analysis
        </Link>
      </td>
    </tr>
  );
}

export default SubCategoryRow;
